import { componentProvider } from 'js-component-framework/es';
import ToggleButton from '@/js/ToggleButton';

/**
 * MenuDrawerToggle component.
 */
class MenuDrawerToggle {
  /**
   * Start the component
   */
  constructor({ children, element, options }) {
    this.children = children;
    this.element = element;
    this.options = options;

    // Bind class methods.
    this.init = this.init.bind(this);

    this.init();
  }

  /**
   * Set up the ToggleButton.
   */
  init() {
    this.toggle = new ToggleButton(this.element);
  }
}

const menuDrawerToggleConfig = {
  name: 'menu-drawer-toggle',
  component: MenuDrawerToggle,
};

componentProvider(menuDrawerToggleConfig);
